define('helper-component-parseContent',['exports'], function (exports) {
    'use strict';

    Object.defineProperty(exports, "__esModule", {
        value: true
    });

    var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
        return typeof obj;
    } : function (obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };

    exports.default = function (content) {
        var res = {};

        if (!content) {
            return null;
        }

        if (!Array.isArray(content)) {
            return content.constructor === Object && Object.keys(content).length ? content : null;
        }

        for (var i = 0; i < content.length; i++) {
            if (content[i] && content[i].hasOwnProperty('key') && content[i].hasOwnProperty('value')) {
                res[content[i].key] = content[i].value;
            } else if (content[i] && _typeof(content[i]) === 'object' && Object.keys(content[i]).length) {
                for (var prop in content[i]) {
                    res[prop] = content[i][prop];
                }
            }
        }

        return Object.keys(res).length ? res : null;
    };
});
